import React from "react";
import { Alert } from "@material-tailwind/react";

export function Alerty({ open, setOpen, color = "blue", message = "Cosmo Fleets Hand Message", variant = 'ghost' }) {

  const [timeoutId, setTimeoutId] = React.useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (open) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // auto-close after 3 seconds
      const id = setTimeout(() => {
        setOpen(false);
      }, 30000);
      setTimeoutId(id);
      // cleanup on effect re-run or unmount
      return () => clearTimeout(id);
    }
  }, [open]);

  const handleClick = () => {
    setOpen(false);
  };

  // Map color to brand colors
  const getBrandColor = (color) => {
    switch (color) {
      case 'green':
        return 'green-500';
      case 'red':
        return 'red-500';
      case 'blue':
        return 'blue-500';
      case 'yellow':
        return 'yellow-500';
      default:
        return 'blue-500';
    }
  };

  return (
    <>
      <div className={open ? "p-2" : ""} onClick={handleClick}>
        <Alert
          open={open}
          onClose={() => setOpen(false)}
          color={color || "blue"}
          variant={variant}
          className={`border-4 border-${getBrandColor(color || "blue")} bg-gray-500 text-white`}
        >
          <div className="flex items-center gap-2">
            <span className="font-medium">{message}</span>
          </div>
        </Alert>
      </div>
    </>
  );
}

export default Alerty;
